import styled, { css } from 'styled-components';
import { breakpoint, fontSettings } from '@lerna-core';
import { TooltipDesktopContentStyled } from '../filterTooltip';

export const FilterTogglesContainerStyled = styled.div<{ isMobile: boolean }>`
  position: relative;
  width: 100%;
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_15, theme.FONT)}
  ${breakpoint(
    'mediumDown',
    css`
      margin: 16px 0;
    `
  )};

  ${({ isMobile }): string => (isMobile ? 'margin: 16px 0' : '')}
`;

export const ToggleStyled = styled.div`
  margin-left: auto;
`;

export const FilterToggleWrapperStyled = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  ${TooltipDesktopContentStyled} {
    max-width: 280px;
  }

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;
